import React, { useMemo } from "react";
import { getClassConditionalAppend, getContainerClassPerMaxWidth, handleLinkTarget } from "../../utils";
import { getColors } from "../../utils/getColors";
import { ButtonV2 } from "../ButtonV2";
import { Container, ContainerFW } from "../global";
import { Heading } from "../Heading";
import { ImgV2 } from "../ImgV2";
export const BubbleTitleDescButtons = (props) => {
    const { bgColor } = getColors(props.backgroundColor);
    const linkHrefTarget = handleLinkTarget(props.linkOpenInNewTab);
    const buttonHrefTarget = handleLinkTarget(props.buttonOpenInNewTab);
    const containerMaxWidthClass = getContainerClassPerMaxWidth(props.containerMaxWidth);
    const containerExtraClass = getClassConditionalAppend(containerMaxWidthClass);
    const handleImageContainer = useMemo(() => {
        if (props.imageSrc) {
            return (React.createElement("div", { className: "main-container__image-container" },
                React.createElement(ImgV2, { src: props.imageSrc, alt: props.imageSrc })));
        }
        return React.createElement(React.Fragment, null);
    }, [props.imageSrc]);
    const handleTitle = useMemo(() => {
        if (props.titleH2) {
            return React.createElement(Heading, { design: "h2-regular" }, props.titleH2);
        }
        return React.createElement("h3", null, props.title);
    }, [props.title, props.titleH2]);
    const handleButtonDesign = useMemo(() => {
        if (props.buttonDesign && props.buttonURL && props.buttonLabel) {
            return React.createElement(ButtonV2, { href: props.buttonURL, design: props.buttonDesign, openInNewTab: props.buttonOpenInNewTab }, props.buttonLabel);
        }
        if (props.buttonLabel && props.buttonURL) {
            return React.createElement("a", { className: "bubbleTitleDescButtons__main-button", href: props.buttonURL, target: buttonHrefTarget },
                " ",
                props.buttonLabel);
        }
        return React.createElement(React.Fragment, null);
    }, [buttonHrefTarget, props.buttonDesign, props.buttonLabel, props.buttonOpenInNewTab, props.buttonURL]);
    return (React.createElement("div", { className: "bubbleTitleDescButtons" },
        React.createElement(ContainerFW, { backgroundColor: bgColor, className: containerExtraClass },
            React.createElement(Container, { className: containerExtraClass },
                React.createElement("div", { className: "bubbleTitleDescButtons__main-container", style: { "--background-card-color": props.backgroundCardColor, "--border-radius-card": props.borderRadiusCard } },
                    handleImageContainer,
                    React.createElement("div", { className: `bubbleTitleDescButtons__text-container ${props.titleH2 ? "with-title-h2" : ""}` },
                        handleTitle,
                        props.description && React.createElement("div", { dangerouslySetInnerHTML: { __html: props.description } })),
                    (props.buttonLabel || props.linkLabel) && React.createElement("div", { className: "bubbleTitleDescButtons__buttons-container" },
                        handleButtonDesign,
                        props.linkLabel && (React.createElement("a", { className: "bubbleTitleDescButtons__demo-link bubbleTitleDescButtons__with-arrow", href: props.linkURL, target: linkHrefTarget }, props.linkLabel))))))));
};
